import React, { Component } from "react";
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Message, Icon, Container, Divider } from 'semantic-ui-react';
import { loginUser, checkLoginStatus } from './actions/login-actions';
import Loadable from 'react-loadable';
import { FormattedMessage } from 'react-intl';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { appInsightsInstKey } from './env/environment';
//basic components
import Loading from './components/loading-component';
import LayoutHeader from './components/layout-header';
import LayoutFooter from './components/layout-footer';
import Home from './pages/home-page';

//n corre app insights em localhost
if(appInsightsInstKey !== ''){
    const appInsights = new ApplicationInsights({ config: {
        instrumentationKey: appInsightsInstKey
    /* ...Other Configuration Options... */
    }});
    appInsights.loadAppInsights();
}
//async components, only loaded when needed
const UnitListPage = Loadable({
    loader: () => import(/* webpackChunkName: "unit-list-page" */ "./pages/unit-list-page"),
    loading: Loading
});
const UnitFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "unit-form-page" */ "./pages/unit-hidro-form-page"),
    loading: Loading
});
const UnitTermFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "unitTerm-form-page" */ "./pages/unit-term-form-page"),
    loading: Loading
});
const UserListPage = Loadable({
    loader: () => import(/* webpackChunkName: "user-list-page" */ "./pages/user-list-page"),
    loading: Loading
});
const UserFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "user-form-page" */ "./pages/user-form-page"),
    loading: Loading
});
const InstructionListPage = Loadable({
    loader: () => import(/* webpackChunkName: "instruction-list-page" */ "./pages/instruction-hidro-list-page"),
    loading: Loading
});
const InstructionTermListPage = Loadable({
    loader: () => import(/* webpackChunkName: "instructionTerm-list-page" */ "./pages/instruction-term-list-page"),
    loading: Loading
});
const ProductionListPage = Loadable({
    loader: () => import(/* webpackChunkName: "production-list-page" */ "./pages/production-hidro-list-page"),
    loading: Loading
});
const ProductionTermListPage = Loadable({
    loader: () => import(/* webpackChunkName: "productionTerm-list-page" */ "./pages/production-term-list-page"),
    loading: Loading
});
const HistoryListPage = Loadable({
    loader: () => import(/* webpackChunkName: "history-list-page" */ "./pages/history-hidro-list-page"),
    loading: Loading
});
const HistoryTermListPage = Loadable({
    loader: () => import(/* webpackChunkName: "historyTerm-list-page" */ "./pages/history-term-list-page"),
    loading: Loading
});
const CenterPage = Loadable({
    loader: () => import(/* webpackChunkName: "center-page" */ "./pages/center-page"),
    loading: Loading
});
const RulesPage = Loadable({
    loader: () => import(/* webpackChunkName: "rules-page" */ "./pages/rules-page"),
    loading: Loading
});
const RulesFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "rules-form-page" */ "./pages/rules-form-page"),
    loading: Loading
});
const CIPage = Loadable({
    loader: () => import(/* webpackChunkName: "ci-page" */ "./pages/ci-page"),
    loading: Loading
});
const CIFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "ci-form-page" */ "./pages/ci-form-page"),
    loading: Loading
});
const IOPage = Loadable({
    loader: () => import(/* webpackChunkName: "io-page" */ "./pages/io-page"),
    loading: Loading
});
const IOFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "io-form-page" */ "./pages/io-form-page"),
    loading: Loading
});
const FIPage = Loadable({
        loader: () => import(/* webpackChunkName: "fi-page" */ "./pages/fi-page"),
        loading: Loading
});
const FIFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "fi-form-page" */ "./pages/fi-form-page"),
    loading: Loading
});
const CCPage = Loadable({
    loader: () => import(/* webpackChunkName: "cc-page" */ "./pages/cc-page"),
    loading: Loading
});
const CCFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "cc-form-page" */ "./pages/cc-form-page"),
    loading: Loading
});
const FCPage = Loadable({
    loader: () => import(/* webpackChunkName: "fc-page" */ "./pages/fc-page"),
    loading: Loading
});
const FCFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "fc-form-page" */ "./pages/fc-form-page"),
    loading: Loading
});
const ToDoIndispsConds = Loadable({
    loader: () => import(/* webpackChunkName: "to-do-indisps-conds-page" */ "./pages/to-do-indisps-conds-page"),
    loading: Loading
});
const AllSheetsView = Loadable({
    loader: () => import(/* webpackChunkName: "to-do-indisps-conds-page" */ "./pages/all-sheets-page"),
    loading: Loading
});
const OpenFIsPage = Loadable({
    loader: () => import(/* webpackChunkName: "open-fis-page" */ "./pages/open-sheets-page"),
    loading: Loading
});
const AlarmsPage = Loadable({
    loader: () => import(/* webpackChunkName: "alarms-page" */ "./pages/alarms-page"),
    loading: Loading
});
const DefaultErrorPage = Loadable({
    loader: () => import(/* webpackChunkName: "error-page" */ "./pages/error-page"),
    loading: Loading
});

/**Modulos HC */
const CPPage = Loadable({
    loader: () => import(/* webpackChunkName: "cp-page" */"./pages/cp-page"),
    loading: Loading
});
const CPFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "cp-form-page"  */"./pages/cp-form-page"),
    loading: Loading
});
const FPPage = Loadable({
    loader: () => import(/* webpackChunkName: "fp-page" */"./pages/fp-page"),
    loading: Loading
});
const FPFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "fp-form-page" */"./pages/fp-form-page"),
    loading: Loading
});
const PMPage = Loadable({
    loader: () => import(/* webpackChunkName: "pm-page" */"./pages/pm-page"),
    loading: Loading
});
const PMFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "pm-form-page" */"./pages/pm-form-page"),
    loading: Loading
});
const ISPage = Loadable({
    loader: () => import(/* webpackChunkName: "is-page" */"./pages/is-page"),
    loading: Loading
});
const ISFormPage = Loadable({
    loader: () => import(/* webpackChunkName: "pm-form-page" */"./pages/is-form-page"),
    loading: Loading
});
const ToDoPlansIndisps = Loadable({
    loader: () => import(/* webpackChunkName: "to-do-indisps-conds-page" */ "./pages/to-do-plans-indisps-page"),
    loading: Loading
});


const loginErrorMessage = (
  <Container style={{ paddingTop: '80px', paddingLeft: '20px' }}>
    <Divider hidden/>    
    <Message icon negative>
      <Icon name='wait' />
      <Message.Content>
        <Message.Header>
          <FormattedMessage id="message.errorUser" />
        </Message.Header>
      </Message.Content>
    </Message>
  </Container>
);

class App extends Component {

    componentWillMount(){
        this.props.checkLoginStatus();
    };

    render() {

        const {user, isLoginSuccess, isLoginPending, loginError} = this.props;

        return (
            <div>
                <LayoutHeader user={ user }/>
        
                { isLoginPending && <Loading /> }
                { loginError && loginErrorMessage }

                { isLoginSuccess && 
                    <div>
                        <Switch>
                            <Route exact path='/' component={Home}/>
                            <Route path='/inst' component={InstructionListPage}/>
                            <Route path='/instrTerm' component={InstructionTermListPage}/>
                            <Route path='/cent' component={CenterPage}/>
                            <Route path='/prod' component={ProductionListPage}/>
                            <Route path='/prodTerm' component={ProductionTermListPage}/>
                            <Route path='/hist' component={HistoryListPage}/>
                            <Route path='/histTerm' component={HistoryTermListPage}/>
                            <Route exact path='/units' component={UnitListPage}/>
                            <Route path="/units/new" component={UnitFormPage}/>
                            <Route path="/units/edit/:id" component={UnitFormPage}/>
                            <Route path="/unitsTerm/new" component={UnitTermFormPage}/>
                            <Route path="/unitsTerm/edit/:id" component={UnitTermFormPage}/>
                            <Route exact path='/users' component={UserListPage}/>
                            <Route path="/users/new" component={UserFormPage}/>
                            <Route path="/users/edit/:id" component={UserFormPage}/>
                            <Route exact path='/rules' component={RulesPage}/>
                            <Route path="/rules/new" component={RulesFormPage}/>
                            <Route path="/rules/edit/:id" component={RulesFormPage}/>
                            <Route exact path="/cis" component={CIPage}/>
                            <Route path="/cis/edit/:id" component={CIFormPage}/>
                            <Route exact path="/ios" component={IOPage}/>
                            <Route path="/ios/edit/:id" component={IOFormPage}/>
                            <Route exact path="/fis" component={FIPage}/>
                            <Route path="/fis/edit/:id" component={FIFormPage}/>
                            <Route exact path="/ccs" component={CCPage}/>
                            <Route path="/ccs/edit/:id" component={CCFormPage}/>
                            <Route exact path="/fcs" component={FCPage}/>
                            <Route path="/fcs/edit/:id" component={FCFormPage}/>
                            <Route exact path="/todoindispsconds" component={ToDoIndispsConds}/>
                            <Route exact path="/allfs" component={AllSheetsView}/>
                            <Route exact path="/openfis" component={OpenFIsPage}/>
                            <Route exact path="/alarms" component={AlarmsPage}/>

                            <Route exact path="/cps" component={CPPage}/>
                            <Route path="/cps/edit/:id" component={CPFormPage}/>
                            <Route exact path="/fps" component={FPPage}/>
                            <Route path="/fps/edit/:id" component={FPFormPage}/>
                            <Route exact path="/pms" component={PMPage}/>
                            <Route exact path="/pms/edit/:id" component={PMFormPage}/>
                            <Route exact path="/iss" component={ISPage}/>
                            <Route exact path="/iss/edit/:id" component={ISFormPage}/>
                            <Route exact path="/todoplansindisps" component={ToDoPlansIndisps}/>
                            <Route path='/PageNotFound' component={DefaultErrorPage}/>
                            <Redirect from='*' to='/PageNotFound' />             
                        </Switch>
                        <LayoutFooter user={ user }/>
                    </div>      
                }
            </div>
        );
    }
}

// Let's map the store state (th input parameter) to local props 
// that we can access inside our components by using this.props.<key> 
// By linking I mean the object returned by mapStateToProps will be provided at 
// construction time as props and any subsequent change will be available 
// through componentWillReceiveProps.
const mapStateToProps = (state) => {
  
  return {
      isLoginSuccess: state.loginStore.isLoginSuccess,
      isLoginPending: state.loginStore.isLoginPending,
      loginError: state.loginStore.loginError,
      user: state.loginStore.user
  };
};

// And then we need another function to be able to dispatch our blobsFetchData() action creator with a prop.

const mapDispatchToProps = (dispatch) => {
  return {
    checkLoginStatus: () => dispatch(checkLoginStatus()),
    loginUser: () => dispatch(loginUser())    
  };
};


//export default App;
//export default withRouter(App);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js